import { AxiosResponse } from 'axios';

import { LOGIN_URL, REFRESH_URL } from 'const';
import Storage from 'utils/storage';

type RefreshFn = (config: AxiosResponse) => Promise<void>;
type RemoveFn = () => void;

const errorHandler = (refreshFn: RefreshFn, removeFn: RemoveFn) => (error: any) => {
	if (error.response) {
		switch (error.response.status) {
			case 401: {
				handler401(error, refreshFn, removeFn);
				break;
			}

			default:
			break;
		}
	}
};

function handler401(error: any, refreshFn: RefreshFn, removeFn: RemoveFn) {
	const currentUrl = error.response.config.url || '';
	if (currentUrl === LOGIN_URL || currentUrl === REFRESH_URL) return;

	if (Storage.getItem('rememberMe')) {
		refreshFn(error.response.config);
	} else {
		removeFn();
	}
}

export default errorHandler;
